import React from "react";

function Merchandise() {
  return (
    <div className="merchandise">
      <h2>Add/Edit Merchandise</h2>
      {/* Add form and table for merchandise */}
    </div>
  );
}

export default Merchandise;

